// extracted by mini-css-extract-plugin
module.exports = {"articleBox":"Article_articleBox__2cx4U","back":"Article_back__177KC","prevAndNext":"Article_prevAndNext__3BONy"};